import React, {Component} from 'react'
import PropTypes from 'prop-types'
import TableHeadBoxItems from "./TableHeadBoxItems"
import RowBoxItemContainer from "./RowBoxItemContainer";
import {Spin} from "antd";


class ListBoxItems extends Component {
    state = {
        arrSelectedFba: [],
        selectAllFba: false,
    }

    _handleCheckAll = (isChecked) => {
        this.setState(() => {
            if (isChecked) {
                const {items} = this.props
                const itemIdsFba = items.map(itemFba => ({
                    id: itemFba._id,
                    barcode: (!!itemFba && !!itemFba.item_number && !!itemFba.item_index) ? `${itemFba.item_number}_${itemFba.item_index}` : ''
                }))

                return {
                    arrSelectedFba: itemIdsFba,
                    selectAllFba: true,
                }
            }

            return {
                arrSelectedFba: [],
                selectAllFba: false,
            }
        })
    }

    _updateSelectedBox = (itemFba, isAdded) => {
        const {_id : idFba, item_number, item_index} = Object.assign({}, itemFba)
        this.setState(({arrSelectedFba}) => {
            if (isAdded && !arrSelectedFba.some(iFba => iFba.id === idFba)) {
                return {
                    arrSelectedFba: [...arrSelectedFba, {
                        id: idFba,
                        barcode: (!!item_number && !!item_index) ? `${item_number}_${item_index}` : ''
                    }],
                    selectAllFba: arrSelectedFba.length + 1 === this.props.items.length,
                }
            } else {
                const filteredFba = arrSelectedFba.filter(iFba => iFba.id !== idFba)

                return {
                    arrSelectedFba: filteredFba,
                    selectAllFba: false,
                }
            }
        })
    }

    render() {
        const {items: itemsFba, isPrivate, onRefresh, box, loading, isAdmin, showDelete, handleCheckDelete, incompleteOrders} = this.props
        const {selectAllFba, arrSelectedFba} = this.state

        // Tạo Map 1 lần ở đây thay vì để mỗi dòng tự .find(): thùng FBA có thể chứa
        // hàng trăm item và bảng re-render sau mỗi lần quét barcode
        const vIncompleteOrders = Array.isArray(incompleteOrders) ? incompleteOrders : []
        const incompleteMap = new Map(vIncompleteOrders.map(order => [order.barcodeNumber, order]))

        return (
            <div className="ListBoxItems mt-3">
                <table className="table">
                    <TableHeadBoxItems
                        isAdmin={isAdmin}
                        showDelete={showDelete}
                        handleCheckDelete={handleCheckDelete}
                        onCheckAll={this._handleCheckAll}
                        selectAll={selectAllFba}
                        arrSelected={arrSelectedFba}
                        onRefresh={onRefresh}
                        box={box}
                    />
                    {
                        loading ? '' :
                        <RowBoxItemContainer
                            items={itemsFba}
                            onRefresh={onRefresh}
                            isPrivate={isPrivate}
                            box={box}
                            showDelete={showDelete}
                            onSelected={this._updateSelectedBox}
                            arrSelected={arrSelectedFba}
                            onCheckAll={this._handleCheckAll}
                            incompleteMap={incompleteMap}
                        />
                    }
                </table>

                {
                    loading ? <Spin spinning={loading} tip='Đang tải...' className='next-boxes-loading'/> : ''
                }
            </div>
        )
    }
}

ListBoxItems.propTypes = {
    box: PropTypes.object.isRequired,
    items: PropTypes.array.isRequired,
    incompleteOrders: PropTypes.array,
    onRefresh: PropTypes.func.isRequired,
    isPrivate: PropTypes.bool.isRequired,
}

export default ListBoxItems
